var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":"/img/brand/logo-white.svg","alt":"logo loader"}}),_c('v-progress-circular',{attrs:{"size":50,"indeterminate":"","color":'#ffb511'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }